<template>
  <div class="huanqiu-logRecord-page-out">
    <topNav ref="topnav"
            selfMethod="1"
            @leftClick="goBack"
            title="日志查看"></topNav>
    <mt-cell title="房态更新日志" to="/opera/logRecordRoom" is-link></mt-cell>
    <mt-cell title="楼栋绑定日志" to="/opera/logRecordBindBuild" is-link></mt-cell>
  </div>
</template>

<script>
  import moment from "moment";
  import nothing from "../common/nothing";
  import topNav from "../common/topNav";
  import {
    Toast,
  } from "mint-ui";

  export default {
    data() {
      return {
      };
    },
    computed: {},
    mounted() {
    },
    methods: {
      goBack(){
        this.$router.back()
      },
      msg(msg) {
        Toast({
          message: msg,
          position: "bottom",
          duration: 3000
        });
      }
    },
    filters: {
      dateF(value) {
        return value != "" ? value.replace(/-/g, "/").substring(5, 10) : "";
      },
      ddate(value) {
        if (value != null && value != "") {
          let arr = value.split(",");
          if (arr.length == 2) {
            return arr[0].substring(0, 10) + " -- " + arr[1].substring(0, 10);
          }
        }
        return value;
      },
      fdate(value) {
        return value == null || value == "" ?
          null :
          moment(value).format("YYYY-MM-DD");
      }
    },
    components: {
      nothing, topNav
    }
  };
</script>

<style lang="less">
  .huanqiu-logRecord-page-out {
  }
</style>



// WEBPACK FOOTER //
// logRecordHuanQiu.vue?04a889c7